import { Search } from "lucide-react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export function ExpandingSearchBar({
	placeholder,
	className,
	id,
	name,
	...props
}: React.InputHTMLAttributes<HTMLInputElement>) {
	return (
		<div className={cn("relative w-full max-w-[12.5rem]", className)}>
			<Input
				{...props}
				id={id ?? "search-input"}
				name={name ?? "search"}
				type="search"
				autoComplete="off"
				placeholder={placeholder ?? "Search..."}
				className="h-9 w-full bg-background pr-9 [&::-webkit-search-cancel-button]:hidden"
			/>
			<Search
				className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
				aria-hidden
			/>
		</div>
	);
}
